export const columns = [
    {
        title:'标题',
        dataIndex:"title",
        key:"title"
    },
    {
        title:'产品logo',
        dataIndex:"logo",
        key:"logo",
        slots:"logo"
    },

    {
        title:'产品名称',
        dataIndex:"productName",
        key:"productName"
    },
    {
        title:'公司名称',
        dataIndex:"companyName",
        key:"companyName"
    },
    {
        title:'碳标签',
        dataIndex:"attachment",
        key:"attachment",
        slots:"attachment"
    },
    {
        title:'操作人',
        dataIndex:"revisorName",
        key:"revisorName"
    },
    {
        title:'操作时间',
        dataIndex:"updateTime",
        key:"updateTime"
    },
    {
        title: "操作",
        slots:'actions',
        width:180,
        fixed:'right'
    },
]